import { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";

// Matches DLA BUS's own console login shape (ops/CONSOLE_AUTH_SCOPE.md) --
// email/password only for now; Google sign-in needs its own OAuth client ID
// setup (a separate, not-yet-done step, not silently half-wired here).

export function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  const forgotPassword = async () => {
    if (!email) { setError("Enter your email first, then click 'Forgot password'"); return; }
    setBusy(true);
    setError(null);
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="center">
      <div className="box">
        <h1>HEC Catalog Console</h1>
        <form onSubmit={submit}>
          <div>
            <input type="email" placeholder="Email" value={email}
                   onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div>
            <input type="password" placeholder="Password" value={password}
                   onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p className="err">{error}</p>}
          {resetSent && <p className="meta" style={{ marginTop: 0 }}>Password reset email sent — check your inbox.</p>}
          <button type="submit" disabled={busy} style={{ width: "100%", marginTop: 6 }}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <button
          type="button"
          onClick={forgotPassword}
          disabled={busy}
          style={{ marginTop: 10, background: "none", border: "none", color: "var(--accent)", padding: 0, minHeight: 0 }}
        >
          Forgot password?
        </button>
      </div>
    </div>
  );
}
